module.exports = __webpack_public_path__ + "static/media/VC-Logo1.d48ea22b.png";